import { render, staticRenderFns } from "./editDomain.vue?vue&type=template&id=62f50ff5&scoped=true"
import script from "./editDomain.vue?vue&type=script&lang=js"
export * from "./editDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f50ff5",
  null
  
)

export default component.exports